import { WIDGET_SIZES_BY_TYPE_MAP } from 'services/constants';
import { WidgetSizeEnum, WidgetTypeEnum } from 'types/schema';

export const getWidgetSizesByType = (type: WidgetTypeEnum): WidgetSizeEnum[] => WIDGET_SIZES_BY_TYPE_MAP[type];
